export interface Rng {
  next: () => number;
}

export function createSeed(level: number, tier: number): number {
  return (level * 1009) ^ (tier * 9173) ^ 0x7f4a7c15;
}

export function createRng(seed: number): Rng {
  let state = seed >>> 0;
  return {
    next: () => {
      state ^= state << 13;
      state ^= state >>> 17;
      state ^= state << 5;
      return (state >>> 0) / 0xffffffff;
    },
  };
}

export function randomInt(rng: Rng, min: number, max: number): number {
  return Math.floor(rng.next() * (max - min + 1)) + min;
}

export function deterministicRoll(seed: number, id: number): number {
  let value = (seed ^ (id * 1103515245)) >>> 0;
  value = (value * 1664525 + 1013904223) >>> 0;
  return (value & 0xffffff) / 0xffffff;
}
